
import { overflowContainerMixin } from '../../mixins'
import EoButton from '../EoButton/EoButton.vue'
import EoIcon from '../EoIcon/EoIcon.vue'
import EoImg from '../EoImg/EoImg.vue'

export default {
  name: 'EoYoutube',
  components: { EoButton, EoIcon, EoImg },
  mixins: [overflowContainerMixin],
  props: {
    /**
     * ID of the Youtube video or playlist
     */
    id: {
      type: String,
      default: '',
    },
    /**
     * Are cookies enabled and allowed by the user?
     */
    cookiesAllowed: {
      type: Boolean,
      default: false,
    },
    /**
     * Autoplay the video
     */
    autoplay: {
      type: Boolean,
      default: false,
    },
    /**
     * Overwrite default placeholder image (before player is loaded)
     */
    poster: {
      type: String,
      default: null,
    },
    /**
     * Hide and remove the iframe from the DOM
     */
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      return {
        'eo-youtube': true,
        'is-allowed': this.cookiesAllowed,
      }
    },
    normalizedId () {
      /**
       * Extrude the YouTube ID from various YouTube URLs
       */
      if (!this.id) return null
      let id = ''
      if (this.id.includes('list=')) {
        // URL is a playlist
        id = this.id.substr((this.id.indexOf('list=') + 5), (this.id.indexOf('&') || null))
      } else {
        // URL is not a playlist
        const splittedUrl = this.id.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
        if (splittedUrl[2] !== undefined) {
          id = splittedUrl[2].split(/[^0-9a-z_\-]/i)
          id = id[0]
        } else {
          id = this.id
        }
      }
      return id
    },
    type () {
      return this.normalizedId?.startsWith('PL') ? 'playlist' : 'video'
    },
    src () {
      const autoplayParameters = this.autoplay ? 'autoplay=1&mute=0' : ''
      if (this.type === 'video') {
        return `https://www.youtube-nocookie.com/embed/${this.normalizedId}?${autoplayParameters}`
      } else {
        return `https://www.youtube-nocookie.com/embed/videoseries?list=${this.normalizedId}${autoplayParameters}`
      }
    },
    posterUrl () {
      const url = this.poster || `https://img.youtube.com/vi/${this.normalizedId}/0.jpg`
      return url
    },
  },
  mounted () {
    this.$emit('poster', this.posterUrl)
  },
}
